export const lightGreen = {
  500: 'hsla(88, 50%, 53%, 1)',
};

export type LightGreenPalette = typeof lightGreen;
